module.exports = __webpack_public_path__ + "img/mockup-move-apps-DE.d8c62013.png";